/**
 * Gate review card — pass/fail result with expandable detail.
 *
 * CSS: styles/components/gate-card.css
 */

import { esc } from '../../shared/rendering.js'
import { action } from './action-delegation.js'
import type { GateCardProps } from '../../types/components.js'

/** Render a gate review card (pass or fail). Click expands to show response + files. */
export function renderGateCard(props: GateCardProps): string {
  const cls = props.type === 'pass' ? 'pass' : 'fail'
  const filesHtml = (props.files ?? []).map((f) => `<div class="gate-fi">${esc(f)}</div>`).join('')

  return `<div class="gate ${cls}" role="button" tabindex="0" aria-expanded="false" ${action('toggleGateExpand')}>
    <div class="gate-h">
      <span class="gate-lbl">${esc(props.label)}</span>
      <span style="font-size:9px;color:var(--t4);margin-left:auto">&#9654;</span>
    </div>
    ${props.summary ? `<div class="gate-sum">${esc(props.summary)}</div>` : ''}
    ${props.detail ? `<div class="gate-det">${esc(props.detail)}</div>` : ''}
    <div class="gate-expand">
      ${props.response ? `<div class="gate-response">${esc(props.response)}</div>` : ''}
      ${filesHtml ? `<div class="gate-files">${filesHtml}</div>` : ''}
    </div>
  </div>`
}
